module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.a4d31128b633bc0b1cc1.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module id = ../../../../material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module chunks = styles